import React, { type FC, type PropsWithChildren } from 'react';
import { useCurrentPriority, loadingPriority } from './PriorityManager.tsx';

export const BackgroundPriority: FC<PropsWithChildren<{ forceRender?: boolean }>> = ({
	children,
	forceRender,
}) => {
	const tier = useCurrentPriority();
	if (!forceRender && tier < loadingPriority.background) {
		return null;
	}
	return <>{children}</>;
};

export const renderInBackgroundPriority = (Component: FC, bypassCondition?: () => boolean): FC => {
	const wrappedComponent = () => (
		<BackgroundPriority forceRender={bypassCondition ? bypassCondition() : false}>
			<Component />
		</BackgroundPriority>
	);
	wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
	return wrappedComponent;
};
